import React, { useState } from 'react'

const useTransportValue = () => {
    const [inputVC, setInputVC] = useState(0)
    const [inputPagueFlex, setInputPagueFlex] = useState(0)
    const [inputVloz, setInputVloz] = useState(0)


    const [priceAll, setPriceAll] = useState({
        limiteVotorantim:{
          value: ""
        },
        limiteFlex:{
          value: ""
        },
        limiteVloz:{
          value:""
        }

      })



  return{
    priceAll,
    setPriceAll,
    inputVloz,
    setInputVloz,
    setInputPagueFlex,
    inputPagueFlex,
    setInputVC,
    inputVC


  }
}

export default useTransportValue